import { render, staticRenderFns } from "./ShopSearch.vue?vue&type=template&id=bec3634a&lang=html&"
import script from "./ShopSearch.vue?vue&type=script&lang=js&"
export * from "./ShopSearch.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ShopSearch.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0edffa0a"
  
)

export default component.exports